import { render, staticRenderFns } from "./CompanySetting.vue?vue&type=template&id=7b54ad2a&scoped=true"
import script from "./CompanySetting.vue?vue&type=script&lang=js"
export * from "./CompanySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b54ad2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b54ad2a')) {
      api.createRecord('7b54ad2a', component.options)
    } else {
      api.reload('7b54ad2a', component.options)
    }
    module.hot.accept("./CompanySetting.vue?vue&type=template&id=7b54ad2a&scoped=true", function () {
      api.rerender('7b54ad2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/onboarding/CompanySetting.vue"
export default component.exports